/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Size_TitleInputs */

const vi_lot_size_title = /** @type {(inputs: Lot_Size_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Định mức lô`)
};

/**

* @param {Lot_Size_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_size_title = /** @type {((inputs?: Lot_Size_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Size_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_size_title(inputs)
});